import { useQuery } from 'react-query'
import { savedAudienceService } from '@marketing-milk/frontend'
import { useMemo } from 'react'
import { getDefaultAudiences } from 'pages/business/campaigns/helpers/campaignForm.helpers'

export function useFetchAllAudiences(businessID: string) {
  const {
    data: audiences,
    isLoading,
    isError,
    refetch,
  } = useQuery(['audiences', businessID], () => savedAudienceService.getAll(businessID), {
    refetchOnMount: false,
  })

  // Memoized rather than derived inline: consumers put `defaultAudiences` in effect dependency
  // arrays, and a fresh array identity every render would re-fire those effects.
  const defaultAudiences = useMemo(() => getDefaultAudiences(audiences ?? []), [audiences])

  return { audiences, isLoading, isError, refetch, defaultAudiences }
}
